import { WhatsappReachoutStatus } from "@shared/lib/types/briefInfluencerV2";

export const WHATSAPP_REACHOUT_STATUS_FILTER_OPTIONS: {
  name: string;
  value: WhatsappReachoutStatus;
}[] = [
  {
    name: getWhatsappReachoutStatusLabel(WhatsappReachoutStatus.Pending),
    value: WhatsappReachoutStatus.Pending,
  },
  {
    name: getWhatsappReachoutStatusLabel(WhatsappReachoutStatus.NotSent),
    value: WhatsappReachoutStatus.NotSent,
  },
  // {
  //   name: getWhatsappReachoutStatusLabel(WhatsappReachoutStatus.Processing),
  //   value: WhatsappReachoutStatus.Processing,
  // },
  {
    name: getWhatsappReachoutStatusLabel(WhatsappReachoutStatus.Sent),
    value: WhatsappReachoutStatus.Sent,
  },
  {
    name: getWhatsappReachoutStatusLabel(WhatsappReachoutStatus.Delivered),
    value: WhatsappReachoutStatus.Delivered,
  },
  {
    name: getWhatsappReachoutStatusLabel(WhatsappReachoutStatus.Read),
    value: WhatsappReachoutStatus.Read,
  },
  {
    name: getWhatsappReachoutStatusLabel(WhatsappReachoutStatus.Replied),
    value: WhatsappReachoutStatus.Replied,
  },
  {
    name: getWhatsappReachoutStatusLabel(WhatsappReachoutStatus.Failed),
    value: WhatsappReachoutStatus.Failed,
  },
];

export type WhatsappReachoutStatusClassKey =
  | "notSent"
  | "processing"
  | "sent"
  | "delivered"
  | "read"
  | "replied"
  | "failed";

export function getWhatsappReachoutStatusLabel(
  status?: WhatsappReachoutStatus
): string {
  if (!status) {
    return "Not Sent";
  }

  switch (status) {
    case WhatsappReachoutStatus.Pending:
      return "Pending";
    case WhatsappReachoutStatus.NotSent:
      return "Not Sent";
    case WhatsappReachoutStatus.Processing:
      return "Processing";
    case WhatsappReachoutStatus.Sent:
      return "Sent";
    case WhatsappReachoutStatus.Delivered:
      return "Delivered";
    case WhatsappReachoutStatus.Read:
      return "Read";
    case WhatsappReachoutStatus.Replied:
      return "Replied";
    case WhatsappReachoutStatus.Failed:
      return "Failed";
    default:
      return "Not Sent";
  }
}

export function isInitialReachoutStatus(
  status?: WhatsappReachoutStatus
): boolean {
  return (
    status === undefined ||
    status === WhatsappReachoutStatus.NotSent ||
    status === WhatsappReachoutStatus.Pending
  );
}

export function getWhatsappReachoutStatusClassKey(
  status?: WhatsappReachoutStatus
): WhatsappReachoutStatusClassKey {
  if (!status) {
    return "notSent";
  }

  switch (status) {
    case WhatsappReachoutStatus.Pending:
    case WhatsappReachoutStatus.NotSent:
      return "notSent";
    case WhatsappReachoutStatus.Processing:
      return "processing";
    case WhatsappReachoutStatus.Sent:
      return "sent";
    case WhatsappReachoutStatus.Delivered:
      return "delivered";
    case WhatsappReachoutStatus.Read:
      return "read";
    case WhatsappReachoutStatus.Replied:
      return "replied";
    case WhatsappReachoutStatus.Failed:
      return "failed";
    default:
      return "notSent";
  }
}
